import { useSidebarToggle } from "../../hooks/use-sidebar-toggle";
import { Chrome, Send } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { useStore } from "zustand";

export function Footer() {
  const textareaRef = useRef(null);
  const [value, setValue] = useState("");
  const sidebar = useStore(useSidebarToggle, (state) => state);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  const handleInputChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <div className="z-20 w-full bg-body">
      <div className="mx-4 md:mx-8 flex h-10 items-center justify-center">
        <p className="text-xs md:text-sm leading-loose text-muted-foreground text-center">
          GuideproAI can make mistakes. Consider checking important information.
        </p>
      </div>
    </div>
  );
}
